module.exports = __webpack_public_path__ + "media/assets/File-0d42ea9b938cd99e78f113b2d9627e02.svg";